import React from 'react';
import { User } from 'lucide-react';
import { teamMembers } from '../data/mock';

const Team = () => {
  const styles = `
    .img-wrapper {
      aspect-ratio: 3/4;
    }
  `;

  return (
    <section id="team" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <style>{styles}</style>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Meet Our Team
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Dedicated professionals committed to delivering excellence
            </p>
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>

          {/* Team Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="bg-white rounded-xl p-4 shadow-md hover:shadow-xl transition-all duration-300 group"
              >
                {/* Avatar */}
                <div className="flex justify-center mb-6">
                  <div className="relative">
                    {member.avatar ? (
                      <div className="img-wrapper w-72 rounded-2xl overflow-hidden border-2 border-blue-500 shadow-lg group-hover:scale-105 group-hover:shadow-xl transition-all duration-300 bg-gray-100">
                        <img src={member.avatar} alt={member.name} className="w-full h-full object-cover object-center absolute inset-0" />
                      </div>
                    ) : (
                      <div className="img-wrapper w-72 rounded-2xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center border-2 border-blue-500 shadow-lg group-hover:scale-105 transition-all duration-300">
                        <User className="text-blue-600" size={56} strokeWidth={1.5} />
                      </div>
                    )}
                  </div>
                </div>

                {/* Member Info */}
                <div className="text-center">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-md font-semibold text-blue-600">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;